import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function BookingQueueAvailable({ rideBookingLogicData }) {
    const isEtaAvailable =
        rideBookingLogicData.bookingQueueStatus.bestAvailableDriverEta !== undefined &&
        rideBookingLogicData.bookingQueueStatus.bestAvailableDriverEta !== null;
    const isEstimatedEtaAvailable =
        rideBookingLogicData.bookingQueueStatus.estimatedDriverHeadingBackEta !== undefined &&
        rideBookingLogicData.bookingQueueStatus.estimatedDriverHeadingBackEta !== null;

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 6,
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {!isEtaAvailable && !isEstimatedEtaAvailable && (
                    <Typography
                        variant="h3"
                        sx={{
                            ml: 1,
                            fontSize: 32,
                            fontWeight: '600',
                            color: 'white',
                            marginRight: 1,
                        }}
                    >
                        Available
                    </Typography>
                )}

                {(isEtaAvailable || isEstimatedEtaAvailable) && (
                    <Typography
                        variant="h3"
                        sx={{
                            ml: 1,
                            fontSize: 32,
                            fontWeight: '600',
                            color: 'white',
                            marginRight: 1,
                        }}
                    >
                        Available In
                    </Typography>
                )}

                {!isEtaAvailable && !isEstimatedEtaAvailable && (
                    <Typography
                        variant="h3"
                        sx={{
                            color: '#000000',
                            backgroundColor: 'rgb(249,164,9)',
                            borderRadius: 3,
                            paddingLeft: 1.5,
                            paddingRight: 1.5,
                            paddingTop: 1.0,
                            paddingBottom: 1.0,
                            fontSize: 34,
                            fontWeight: '900',
                        }}
                    >
                        Soon
                    </Typography>
                )}

                {isEtaAvailable && (
                    <Typography
                        variant="h3"
                        sx={{
                            color: '#000000',
                            backgroundColor: 'rgb(249,164,9)',
                            borderRadius: 3,
                            paddingLeft: 1.5,
                            paddingRight: 1.5,
                            paddingTop: 1.0,
                            paddingBottom: 1.0,
                            fontSize: 34,
                            fontWeight: '900',
                        }}
                    >
                        {rideBookingLogicData.bookingQueueStatus.bestAvailableDriverEta}
                    </Typography>
                )}

                {isEstimatedEtaAvailable && (
                    <Typography
                        variant="h3"
                        sx={{
                            color: '#000000',
                            backgroundColor: 'rgb(249,164,9)',
                            borderRadius: 3,
                            paddingLeft: 1.5,
                            paddingRight: 1.5,
                            paddingTop: 1.0,
                            paddingBottom: 1.0,
                            fontSize: 34,
                            fontWeight: '900',
                        }}
                    >
                        {rideBookingLogicData.bookingQueueStatus.estimatedDriverHeadingBackEta}
                    </Typography>
                )}
            </Box>

            <Typography
                variant="h3"
                sx={{
                    marginTop: 2,
                    fontSize: 18,
                    color: 'white',
                }}
            >
                Confirm Your Booking Now
            </Typography>
        </Box>
    );
}
